import { Routes } from '@angular/router';


export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '', loadComponent: () => import('./web-development.component').then(m => m.WebDevelopmentComponent),
        data: {
          title: 'KudosHub | Web Development',
          description:'Building easy-to-maintain websites that are elegantly designed to match your brand’s persona and provide a user experience you didn’t think possible.',
          keywords: 'web design, development, website',
          ogTitle: 'KudosHub | Web Development',
          ogDesc: 'Building easy-to-maintain websites that are elegantly designed to match your brand’s persona and provide a user experience you didn’t think possible.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/web-design-development.webp',
          ogUrl: 'https://kudoshub.com/web-development',
          twitterTitle: 'KudosHub | Web Development',
          twitterDesc: 'Building easy-to-maintain websites that are elegantly designed to match your brand’s persona and provide a user experience you didn’t think possible.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/web-design-development.webp'
        }
      }
    ]
  }
];
